const nodes = [
  {
    icon: "ri-megaphone-line",
    tag: "首个爆点",
    date: "06-11",
    title: "一句「想单干」",
    text: "整件事的起点，被切片放大的无心之言。",
    tone: "accent",
  },
  {
    icon: "ri-video-line",
    tag: "全场反转点",
    date: "07-30",
    title: "那段旧录像",
    text: "两年前的内部会议录音，重新定义了争论焦点。",
    tone: "primary",
  },
  {
    icon: "ri-file-text-line",
    tag: "隐藏导火索",
    date: "全程",
    title: "合同里的分成条款",
    text: "真正决定谁走谁留的文字，始终没被公开念完。",
    tone: "secondary",
  },
  {
    icon: "ri-question-line",
    tag: "最新进展",
    date: "08-31",
    title: "官宣后的留白",
    text: "买断金、账号归属未明说，悬念仍在发酵。",
    tone: "accent",
  },
];

const toneMap: Record<string, { badge: string; icon: string; ring: string }> = {
  accent: { badge: "bg-accent-100 text-accent-800", icon: "bg-accent-100 text-accent-700", ring: "hover:border-accent-300" },
  primary: { badge: "bg-primary-100 text-primary-800", icon: "bg-primary-100 text-primary-700", ring: "hover:border-primary-300" },
  secondary: { badge: "bg-secondary-100 text-secondary-800", icon: "bg-secondary-100 text-secondary-700", ring: "hover:border-secondary-300" },
};

export default function KeyNodes() {
  return (
    <section id="guanjian" className="scroll-mt-24 bg-background-100/70">
      <div className="mx-auto max-w-[1240px] px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <p className="flex items-center gap-2 text-sm font-medium text-primary-600">
              <i className="ri-pushpin-2-line h-4 w-4" />
              关键节点 · 速查
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">
              这四个节点，一个都别错过
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-6 text-foreground-600">
            不看时间线也能速读：只要记住谁开口、谁发难、哪一刻反转、现在卡在哪。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {nodes.map((n) => {
            const t = toneMap[n.tone];
            return (
              <article
                key={n.title}
                className={`group flex cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition ${t.ring}`}
              >
                <div className="flex items-center justify-between">
                  <span className={`flex h-10 w-10 items-center justify-center rounded-md ${t.icon}`}>
                    <i className={`${n.icon} h-5 w-5`} />
                  </span>
                  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium ${t.badge}`}>
                    {n.tag}
                  </span>
                </div>
                <p className="mt-5 text-xs tracking-wide text-foreground-400">{n.date}</p>
                <h3 className="mt-1.5 font-heading text-lg font-bold text-foreground-950">{n.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{n.text}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-medium text-foreground-500 transition group-hover:text-primary-600">
                  深挖这段
                  <i className="ri-arrow-right-line h-3.5 w-3.5" />
                </span>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}